import { useEffect } from 'react';

import {
  LANDING_CRITICAL_IMAGES,
  LANDING_DEFERRED_IMAGES,
  LANDING_SLIDER_IMAGES,
} from './landingPageImages';
import { preloadAdjacentImages, preloadImageLink, preloadImages } from '../../utils/landingImagePreload';

export function useLandingImagePreload() {
  useEffect(() => {
    preloadImageLink(LANDING_CRITICAL_IMAGES[0], { fetchPriority: 'high' });
    preloadImages(LANDING_CRITICAL_IMAGES);

    const deferredTimer = window.setTimeout(() => {
      preloadImages(LANDING_DEFERRED_IMAGES);
      preloadAdjacentImages(LANDING_SLIDER_IMAGES, 0);
    }, 300);

    return () => window.clearTimeout(deferredTimer);
  }, []);
}
